module.exports = __webpack_public_path__ + "img/HZ-B5061.1801e820.jpg";